import React, { useState } from 'react';
import I18n from 'i18n-js';
import { RCButton, RCTextWithIcon, RCToast } from '@reverbdotcom/cadence/components';
import { NudgeExploreIcon } from '@reverbdotcom/cadence/icons/react';
import { Listing, NextBestAction } from '@reverbdotcom/commons/src/gql/graphql';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';

import QuickPriceEditModalV2 from '../listings/quick_price_edit/QuickPriceEditModalV2';
import SellerListingsCollectionContext from './SellerListingsCollectionContext';
import { RCTextUtility } from '@reverbdotcom/cadence/components/RCText/RCText';
import {
  CTA_TYPE,
  INSIGHT,
  trackFollowed,
  trackClicked,
  useTrackingContext,
  useTrackImpression,
} from './sellerRecommendationTracking';

interface Props {
  listing: Listing;
  nextBestAction: NextBestAction;
}

export default function NBAPriceDropPresentment({ listing, nextBestAction }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const trackingContext = useTrackingContext();

  const priceMiddle = listing.priceRecommendation?.priceMiddle;

  useTrackImpression(INSIGHT.PRICED_ABOVE_AVERAGE, listing.id, { recommendedPriceCents: priceMiddle?.amountCents ?? undefined });

  const {
    useLazySellerListingsQuery,
  } = React.useContext(SellerListingsCollectionContext);
  const { refetchSellerListings } = useLazySellerListingsQuery();

  return (
    <>
      <div className="seller-listing-insight-presentment">
        <span className="seller-listing-insight-presentment__price-drop-recommendation">
          <RCTextWithIcon
            icon={<NudgeExploreIcon />}
            placement="left"
            size="large"
          >
            <RCTextUtility size="350">
              <SanitizedRender html={nextBestAction.title ?? ''} />
            </RCTextUtility>
          </RCTextWithIcon>
        </span>
        <RCTextUtility size="350">
          <SanitizedRender html={nextBestAction.subtitle ?? ''} />
        </RCTextUtility>
        <RCButton
          variant="outlined"
          size="small"
          onClick={() => {
            trackClicked(INSIGHT.PRICED_ABOVE_AVERAGE, listing.id, CTA_TYPE.ADJUST_PRICE, trackingContext);
            setIsModalOpen(true);
          }}
          fullWidth
        >
          {nextBestAction.ctaText}
        </RCButton>
      </div>

      <QuickPriceEditModalV2
        isOpen={isModalOpen}
        listingId={listing.id}
        requestClose={() => setIsModalOpen(false)}
        onSuccessCallback={() => {
          trackFollowed(INSIGHT.PRICED_ABOVE_AVERAGE, listing.id, trackingContext);
          setIsModalOpen(false);
          setShowToast(true);
          refetchSellerListings([listing.id]);
        }}
      />

      <RCToast
        isOpen={showToast}
        onClose={() => setShowToast(false)}
        text={I18n.t('discovery.listingsManagement.toast.message.success')}
        theme="success"
        delayInterval="short"
      />
    </>
  );
}
